import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { ActivityLog, IActivityLog } from "@/models/activity-log.entity";

/**
 * The activities the logged-in user received, i.e. the ones referencing the user as a target.
 *
 * Deliberately separate from `ActivityLogDataAccessLayer` and `TargetActivityLogDataAccessLayer`:
 * the inbox is filled with one user's activities only, so sharing a cache with the timelines of
 * resource views would let their entries leak into the inbox list.
 */
export const ActivityInboxDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<
  IActivityLog,
  "targetRefId"
> {
  getIdentifier(entity: IActivityLog): string {
    return entity.id;
  }

  mapEntity(entity: IActivityLog): IActivityLog {
    return new ActivityLog(entity);
  }

  mapsConfig = {
    targetRefId: {
      getIdentifier: (entity: IActivityLog) => (entity.target ?? []).map((target) => target.refId)
    }
  };
})();
